import './DisconnectedBanner.css'

export default function DisconnectedBanner() {
    return <div className="disconnectedBanner" style={{zIndex: 99}}>Disconnected!</div>
}